<template>
  <section class="py-20 px-6 bg-soft-white relative" ref="sectionRef">
    <div class="container mx-auto max-w-6xl">
      <!-- Section Header -->
      <div
        class="text-center mb-16"
        v-motion
        :initial="{ opacity: 0, y: 30 }"
        :visible-once="{ opacity: 1, y: 0 }"
        :duration="800"
      >
        <h2 class="text-4xl md:text-5xl font-poppins font-semibold text-dark-gray mb-6">
          About <span class="text-light-purple">Homvisit</span>
        </h2>
        <div class="w-24 h-1 bg-light-purple mx-auto rounded-full mb-8"></div>
        <p class="text-lg text-dark-gray/80 max-w-3xl mx-auto leading-relaxed">
          Homvisit stands as the parent company of Blood Lyf, pioneering accessible healthcare solutions. 
          We bridge the gap between medical expertise and convenience, ensuring quality diagnostic services 
          reach every doorstep with unwavering trust and professionalism.
        </p>
      </div>

      <!-- Cards Container -->
      <div class="grid md:grid-cols-2 gap-8 md:gap-12">
        <!-- Who We Are Card -->
        <div
          class="card-neumorphic group cursor-pointer"
          v-motion
          :initial="{ opacity: 0, y: 50 }"
          :visible-once="{ opacity: 1, y: 0 }"
          :duration="800"
          :delay="200"
          @mouseenter="onCardHover"
          @mouseleave="onCardLeave"
        >
          <div class="text-center">
            <div class="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-neumorphic flex items-center justify-center shadow-soft">
              <div
                class="w-12 h-12 bg-light-purple rounded-full flex items-center justify-center transition-transform duration-500"
                ref="iconRef1"
              >
                <span class="text-white font-bold text-xl">H</span>
              </div>
            </div>
            
            <h3 class="text-2xl font-poppins font-semibold text-dark-gray mb-4">
              Who We Are
            </h3>
            
            <p class="text-dark-gray/70 leading-relaxed mb-6">
              A healthcare technology company committed to making diagnostic services 
              accessible, reliable, and convenient. We combine medical expertise with 
              innovative solutions to serve both individual families and corporate entities.
            </p>
            
            <div class="flex justify-center space-x-4">
              <div class="text-center">
                <div class="text-2xl font-bold text-light-purple">500+</div>
                <div class="text-sm text-dark-gray/60">Happy Clients</div>
              </div>
              <div class="text-center">
                <div class="text-2xl font-bold text-light-purple">50+</div>
                <div class="text-sm text-dark-gray/60">Corporate Partners</div>
              </div>
            </div>
          </div>
        </div>

        <!-- What We Do Card -->
        <div
          class="card-neumorphic group cursor-pointer"
          v-motion
          :initial="{ opacity: 0, y: 50 }"
          :visible-once="{ opacity: 1, y: 0 }"
          :duration="800"
          :delay="400"
          @mouseenter="onCardHover"
          @mouseleave="onCardLeave"
        >
          <div class="text-center">
            <div class="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-neumorphic flex items-center justify-center shadow-soft">
              <div
                class="w-12 h-12 bg-light-purple rounded-full flex items-center justify-center transition-transform duration-500"
                ref="iconRef2"
              >
                <span class="text-white font-bold text-xl">+</span>
              </div>
            </div>
            
            <h3 class="text-2xl font-poppins font-semibold text-dark-gray mb-4">
              What We Do
            </h3>
            
            <p class="text-dark-gray/70 leading-relaxed mb-6">
              We provide comprehensive diagnostic services through home sample collection 
              and corporate medical camps. Our certified professionals ensure accurate, 
              timely results while maintaining the highest standards of safety and hygiene.
            </p>
            
            <div class="space-y-3">
              <div
                v-for="(item, index) in services"
                :key="index"
                class="flex items-center justify-center space-x-2"
                v-motion
                :initial="{ opacity: 0, x: -20 }"
                :visible-once="{ opacity: 1, x: 0 }"
                :duration="500"
                :delay="600 + index * 100"
              >
                <div class="w-2 h-2 bg-light-purple rounded-full"></div>
                <span class="text-dark-gray/70">{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'AboutSection',
  setup() {
    const sectionRef = ref(null)
    const iconRef1 = ref(null)
    const iconRef2 = ref(null)

    const services = [
      'Home Blood Collection',
      'Corporate Health Camps',
      'Diagnostic Consultations'
    ]

    const onCardHover = (e) => {
      e.currentTarget.style.transform = 'translateY(-10px) rotateX(5deg)'
    }

    const onCardLeave = (e) => {
      e.currentTarget.style.transform = 'translateY(0px) rotateX(0deg)'
    }

    return {
      sectionRef,
      iconRef1,
      iconRef2,
      services,
      onCardHover,
      onCardLeave
    }
  }
}
</script>
